var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3027 0.251787C19.3295 0.707124 19.9991 1.73386 19.9991 2.85881V8.57284H29.9987C38.6768 8.57284 45.7122 15.6082 45.7122 24.2864C45.7122 34.402 38.4358 38.9197 36.7662 39.8304C36.543 39.9554 36.293 40 36.043 40C35.0699 40 34.2842 39.2054 34.2842 38.2411C34.2842 37.5715 34.6681 36.9555 35.1591 36.5002C35.9984 35.7145 37.1412 34.1431 37.1412 31.4379C37.1412 26.706 33.3021 22.8668 28.5701 22.8668H19.9991V28.5809C19.9991 29.7058 19.3384 30.7326 18.3027 31.1879C17.2671 31.6432 16.0707 31.4557 15.2315 30.7058L0.946386 17.8492C0.348199 17.2957 0 16.5278 0 15.7154C0 14.9029 0.348199 14.1351 0.946386 13.5905L15.2315 0.733909C16.0707 -0.0249857 17.276 -0.212477 18.3027 0.251787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyArrow);
export default __webpack_public_path__ + "static/media/Reply Arrow.a6a94be756e558746959b31701040dce.svg";
export { ForwardRef as ReactComponent };